/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
export const UpdateUserRequest = core.serialization.object({
    name: core.serialization.string().optional(),
    dashboard: core.serialization.number().optional(),
});
